import { combineReducers } from "redux";
import AsyncStorage from '@react-native-async-storage/async-storage';

// slices
// import chatReducer from './chat/chatSlice'
import userReducer from './auth/authSlice'
import profileReducer from './profile/profileSlice'
import experienceReducer from "./experience/experienceSlice";

const rootPersistConfig = {
  key: "root",
  storage: AsyncStorage,
  keyPrefix: "",
  whitelist: ["user","chat"],
};

const rootReducer = combineReducers({
  user: userReducer,
  // chat: chatReducer,
  experience: experienceReducer,
  profile:profileReducer
})

export { rootPersistConfig, rootReducer };